export const SEGUE_SET_USER = 'SEGUE_SET_USER';
export const SEGUE_RESET = 'SEGUE_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
